import { IntegrationType } from '@logz-pkg/enums';
import { TelemetryAgentSubtypeModel } from '../telemetry-agent/configuration';
import { ManifestIntegrationItemModel } from './manifest-item';
export class IntegrationsManifestModel {
    collectors = [];
    tags = [];
}
export class HubIntegrationsManifest {
    integrations;
    tags;
}
export class GroupedTagCollectors {
    collectors = [];
    title;
}
export class CollectorModel extends ManifestIntegrationItemModel {
    markdown;
}
export class IntegrationCollector extends ManifestIntegrationItemModel {
    integrationType = IntegrationType.COLLECTOR;
}
export class TelemetryAgentCollector extends TelemetryAgentSubtypeModel {
    integrationType = IntegrationType.AGENT;
    type;
    categoryName;
    title;
    id;
    recommendedFor;
    osTags;
    bundle;
}
//# sourceMappingURL=manifest.js.map